module.exports = __webpack_public_path__ + "assets/img/24_422.5c3bc331.jpg";